<button [class]="classes" [disabled]="disabled" containerClass="black--tooltip" type="button" [tooltip]="tooltipText"
    [placement]="tooltipPlacement" [attr.data-cy]="testId">
    <svg-icon *ngIf="iconName" class="icon--left" [name]="iconName" alt=""
        [ngStyle]="{'stroke-width': pathStrokeWidth}"></svg-icon>
    <span *ngIf="!!text">{{ text }}</span>
    <svg-icon *ngIf="iconNameSecond" class="icon--right" [name]="iconNameSecond" alt=""
        [ngStyle]="{'stroke-width': pathStrokeWidth}"></svg-icon>
</button>
